document.addEventListener('DOMContentLoaded', function() {
  const scheduleVisitBtn = document.getElementById('schedule-visit-btn');
  const searchBtn = document.querySelector('.thb-header-search-btn');
  
  if (searchBtn) {
    searchBtn.addEventListener('click', function() {
      const searchSubmit = document.querySelector('.thb-search-submit');
      const searchField = document.querySelector('.search-field');
      
      if (searchSubmit) {
        searchSubmit.setAttribute('style', 'display: block !important');
      }
      
      if (searchField) {
        searchField.setAttribute('style', 'display: block !important');
      }
    });
  }

   if (scheduleVisitBtn) {
     console.log("event fired");
      scheduleVisitBtn.addEventListener('click', function () {
        // Fire GA4 event
        if (typeof gtag !== 'undefined') {
          gtag('event', 'schedule_visit_click', {
            event_category: 'engagement',
            event_label: 'Schedule Visit Button',
            button_location: 'main_cta',
          });
        }
      });
    }
});
